function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "comercial.icon",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Oval-Copy-7",
  fill: "#9CFF00"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy-3",
  cx: 13,
  cy: 13,
  r: 13
})), /*#__PURE__*/React.createElement("g", {
  id: "noun_Shopping-Bag_786174",
  transform: "translate(8.000000, 6.000000)",
  fill: "#000000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.37207584,3.25959457 L7.49815316,3.25959457 L7.49815316,2.59692974 C7.49815316,1.16414092 6.37773947,0 4.99876878,0 C3.61979808,0 2.49938439,1.16414092 2.49938439,2.59692974 L2.49938439,3.25959457 L0.625461709,3.25959457 C0.280719035,3.25959457 0,3.55126944 0,3.90946664 L0,12.3501279 C0,12.7083251 0.280719035,13 0.625461709,13 L9.37453829,13 C9.71928097,13 10,12.7083251 10,12.3501279 L10,3.90690809 C9.99753755,3.54871088 9.71681852,3.25959457 9.37207584,3.25959457 Z M3.75030781,2.59692974 C3.75030781,1.88053533 4.31174588,1.29718559 5.00123122,1.29718559 C5.69071657,1.29718559 6.25215464,1.88053533 6.25215464,2.59692974 L6.25215464,3.25959457 L3.75030781,3.25959457 L3.75030781,2.59692974 Z",
  id: "Shape"
})));

function SvgComercial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "comercial.icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComercial);
export default __webpack_public_path__ + "static/media/comercial.c58ffb26.svg";
export { ForwardRef as ReactComponent };